module.exports = __webpack_public_path__ + "static/img/10012 (3).fa22ff5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10012 (3).webp
// module id = KVuy
// module chunks = 14